import React, {useEffect} from 'react';
import {makeStyles, useTheme} from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import {Helmet} from "react-helmet";
import ScrollAnimation from 'react-animate-on-scroll';

import logo from '../assets/logo.png';
import project1 from '../assets/images/about1.jpg';
import project3 from '../assets/images/about2.jpg';

const useStyles = makeStyles(theme => ({
    container: {
        paddingTop: "100px",
        paddingBottom: "100px",
        paddingLeft: "15%",
        paddingRight: "15%",
        // backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${aboutBg})`,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        overflowX: "hidden",
        [theme.breakpoints.down("sm")]: {
            paddingLeft: "5%",
            paddingRight: "5%",
        },
    },
    logoImage: {
        width: "90px",
        userSelect: "none",
        [theme.breakpoints.down("md")]: {
            width: "80px"
        },
        [theme.breakpoints.down("sm")]: {
            width: "80px",
        },
        [theme.breakpoints.down("xs")]: {
            width: "60px",
        },
    },
    logoTitle: {
        textTransform: "uppercase",
        [theme.breakpoints.down("md")]: {
            fontSize: "25px",
        },
        [theme.breakpoints.down("sm")]: {
            fontSize: "30px",
        },
        [theme.breakpoints.down("xs")]: {
            fontSize: "20px",
        },
    },
    logoSubtitle: {
        textTransform: "uppercase",
        [theme.breakpoints.down("md")]: {
            fontSize: "9.5px",
        },
        [theme.breakpoints.down("sm")]: {
            fontSize: "12px",
        },
        [theme.breakpoints.down("xs")]: {
            fontSize: "7px",
        },
    },
    bodyText: {}
}))


export default function About(props) {
    const classes = useStyles();
    const theme = useTheme();
    const matchesSM = useMediaQuery(theme.breakpoints.down("sm"));
    const matchesXS = useMediaQuery(theme.breakpoints.down("xs"));

    const setMenuSelected = props.setMenuSelected;
    useEffect(() => {
        if (setMenuSelected) {
            window.scrollTo(0, 0);
            setMenuSelected("about");
        }

    }, []);

    return (
        <React.Fragment>
            <Helmet>
                <title>About - home remodeling & home designer</title>
                <meta name="description" key="description"
                      content="We offer small and large home remodeling. We offer home renovations, bathroom remodel, kitchen remodel, floor tiles and home interior with the fastest results and lowest cost."/>
                <meta property="og:title" key="og:title"
                      content="We offer small and large home remodeling. We offer home renovations, bathroom remodel, kitchen remodel, floor tiles and home interior with the fastest results and lowest cost."/>
            </Helmet>

            <Grid container direction="column" className={classes.container} id="about">

                <Grid item>
                    <Typography component="h1" variant="h2" gutterBottom>ABOUT US</Typography>
                </Grid>
                <Grid item>
                    <Typography variant="h1" paragraph>Your Best Choice</Typography>
                </Grid>

                <Grid item style={{marginTop: "50px"}}>
                    <Grid item container direction="row" spacing={5}>
                        <Grid item md={6}>
                            <Grid item container direction="column">
                                <Grid item>
                                    <Grid item container direction="row" alignItems="center" spacing={2}
                                          style={{paddingBottom: "25px"}}>

                                        <img src={logo} alt="Logo" className={classes.logoImage}/>

                                        <Grid item>
                                            <Grid item container direction="column">
                                                <Grid item>
                                                    <Typography component="h1" variant="h1"
                                                                className={classes.logoTitle}>
                                                        Techno Construction, LLC
                                                    </Typography>
                                                </Grid>
                                                <Grid item>
                                                    <Typography variant="h2" style={{letterSpacing: "3px",}}
                                                                className={classes.logoSubtitle}>
                                                        A modern approach to your space planning
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <Typography variant="body1" align="justify" className={classes.bodyText}>
                                        Techno Construction is a general contracting firm licensed in Virginia, Marylan.
                                        We specialize in all aspects of dental and medical office construction,
                                        including design and construction of new buildings, renovations, and expansions.
                                        <br/>
                                        Our team consists of experienced architects, engineers, designers, project
                                        coordinators and subcontractors, all of whom have been involved in their current
                                        field since 1996.
                                        We have assembled this team of talented and professional individuals in order to
                                        better serve the demanding expectations of our clientele.
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item md={6} style={{
                            backgroundImage: `url(${project1})`,
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                            width: matchesSM ? "100%" : "inherit",
                            height: matchesSM ? "400px" : "inherit",
                            marginLeft: matchesXS ? "5%" : null,
                            marginRight: matchesXS ? "5%" : null,
                            minHeight: "400px",
                        }}>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item style={{marginTop: "50px", marginBottom: "50px"}}>
                    <Grid item container direction="row" spacing={5}>
                        <Grid item md={6} sm={6} xs={12}>
                            <Grid item container direction="row" alignItems="center">
                                <Grid item
                                      style={{
                                          position: "relative",
                                          width: "100%"
                                      }}
                                >
                                    <ScrollAnimation animateIn="fadeInRightBig" animateOnce={true}>
                                        <Typography variant="h1"
                                                    style={{
                                                        fontSize: matchesSM ? "150px" : "200px",
                                                        color: theme.palette.common.black,
                                                    }}
                                        >
                                            25
                                        </Typography>
                                    </ScrollAnimation>

                                    <ScrollAnimation animateIn="fadeInLeftBig" animateOnce={true}>
                                        <div style={{position: "absolute", bottom: 0, right: 0}}>
                                            <Typography variant="h1" style={{fontSize: matchesSM ? "20px" : "30px"}}>
                                                years of
                                            </Typography>
                                            <Typography variant="h1" style={{fontSize: matchesSM ? "20px" : "30px"}}>
                                                professional
                                            </Typography>
                                            <Typography variant="h1" style={{fontSize: matchesSM ? "20px" : "30px"}}>
                                                work
                                            </Typography>
                                        </div>
                                    </ScrollAnimation>

                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item md={6} sm={6} xs={12}>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item style={{marginTop: "50px"}}>
                    <Grid item container direction={matchesSM ? "column-reverse" : "row"} spacing={5}
                          style={{width: matchesXS ? "100%" : null}}>
                        <Grid item md={6} style={{
                            backgroundImage: `url(${project3})`,
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                            width: matchesSM ? "100%" : "inherit",
                            height: matchesSM ? "400px" : "inherit",
                            marginLeft: matchesXS ? "5%" : null,
                            marginRight: matchesXS ? "5%" : null,
                            minHeight: "400px",
                        }}>
                        </Grid>
                        <Grid item md={6}>
                            <Grid item container direction="column">
                                <Grid item style={{paddingBottom: "25px"}}>
                                    <Typography variant="h1" className={classes.logoTitle}>
                                        We will Work closely with Designing every Detail of your project
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    <Typography variant="body1" align="justify" className={classes.bodyText}>
                                        Techno Construction, LLC is proud to have put together a group of dedicated
                                        individuals with decades of combined experience in their fields to provide the
                                        highest quality construction services to dental and medical practitioners since
                                        1996.
                                        Our services include construction of new buildings, tenant fit outs and
                                        renovation of existing facilities such as Dental offices, Medical offices,
                                        Optometry offices and more.
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

            </Grid>
        </React.Fragment>

    );
}
